import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import MatrixDropdown from './MatrixDropdown';
import MatrixWhy from '../response/MatrixWhy';
import * as Matrix from '../matrix/Matrix';
import { t } from '../../../utils/translate';
import SimpleLogicList from '../../survey_editor/preview/SimpleLogicList';

const MatrixDropdownQuestion = props => {
  const {
    add_why,
    choices,
    id,
    isDisabled,
    logic,
    name,
    pages,
    rows,
    showLogic,
    why_text,
  } = props;
  return (
    <QuestionWrapper {...props}>
      <Matrix.Table>
        {rows.map((row, rowIndex) => (
          <Matrix.Body key={rowIndex}>
            <Matrix.Row
              based_on={row.based_on}
              id={row.id}
              text={row.text}
              other={row.other}
              questionId={id}
              questionName={name}
            >
              <td key={rowIndex}>
                <MatrixDropdown
                  disabled={isDisabled}
                  name={`questions[${name}-${row.name}]`}
                  questionId={id}
                  rowIndex={rowIndex}
                >
                  <option value="">{t('select_an_option')}</option>
                  {choices.map(choice => (
                    <option key={choice.name} value={choice.name}>
                      {choice.text.replace(/<[^>]*>/g, '')}
                    </option>
                  ))}
                </MatrixDropdown>
              </td>
              {showLogic && logic && logic.length ? (
                <td style={{ backgroundColor: 'white', paddingLeft: '1rem' }}>
                  <SimpleLogicList
                    logic={logic.filter(term => term.matrix_row_id === row.id)}
                    pages={pages}
                    showChoiceLabel={true}
                  />
                </td>
              ) : null}
            </Matrix.Row>
            <MatrixWhy
              add_why={add_why}
              colSpan="2"
              disabled={isDisabled}
              id={id}
              name={name}
              rowName={row.name}
              rowIndex={rowIndex}
              why_text={why_text}
            />
          </Matrix.Body>
        ))}
      </Matrix.Table>
    </QuestionWrapper>
  );
};

MatrixDropdownQuestion.propTypes = {
  add_other: PropTypes.bool,
  add_why: PropTypes.bool,
  choices: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  ranking: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.array.isRequired,
  text: PropTypes.string.isRequired,
  why_text: PropTypes.string,
};

export default MatrixDropdownQuestion;
